const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaCidade: [],
	listaVeiculoTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ENDERECO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'ENDERECO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'ENDERECO_CIDADE_SELECT_LISTADO':
            return {
				...state,
				listaCidade: action.payload.data
			};

		case 'ENDERECO_VEICULO_TIPO_SELECT_LISTADO':
            return {
				...state,
				listaVeiculoTipo: action.payload.data
			};

        default:
            return state;
    }
}
